import { LazyLoadImage } from "react-lazy-load-image-component";
import StarRating from "./StarRating";
import "../Location.css";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="testimonial-card">
      <div className="testimonial-left">
        <div className="testimonial-avatar">
          <LazyLoadImage
            src={testimonial.image}
            alt={testimonial.name}
            effect="blur"
            className="avatar-img"
          />
        </div>

        <div className="testimonial-user">
          <h4>{testimonial.name}</h4>
          <span>{testimonial.location}</span>
        </div>
      </div>

      <div className="testimonial-right">
        <StarRating rating={testimonial.rating} />

        <p>{testimonial.review}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;